import {useSelector} from 'react-redux';
import {selectIsProOrPartyPass} from '~/common/fabric/User/reducers/user';
import {Link} from '~library/atoms/Link';
import {useTracking} from '~library/context/tracking/tracking-context';

import * as styles from './Logo.module.scss';

export const Logo = () => {
  const isProOrPartyPass = useSelector(selectIsProOrPartyPass);
  const {track} = useTracking();

  const image = isProOrPartyPass
    ? 'https://g0.evitecdn.com/images/images/logos/evitepro_logo.svg'
    : 'https://g0.evitecdn.com/images/images/logos/evite-logo-black.svg';

  const handleLogoClick = () => {
    track({
      dataQaId: 'evite-logo',
      href: '/',
      logoType: isProOrPartyPass ? 'pro' : 'free',
    });
  };

  return (
    <Link href="/" data-qa-id="evite-logo" onClick={handleLogoClick}>
      <img
        className={styles.image}
        data-value={isProOrPartyPass ? 'pro' : 'free'}
        alt="Evite logo"
        src={image}
      />
    </Link>
  );
};
